import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserRole } from './UserRoleProvider';

// The Comparative Rater. Access is a per-user grant (a `rater-access` role row) and nothing else —
// not an account role, and not admin, who can grant it but has to grant it to themselves like anyone
// else. The reason is what the Rater does rather than what it reads: a submission imports a real lead
// into QuoteRush and creates a real application in Rocket's portal, both under the agency's own
// credentials. The API enforces the same rule as the 'Rater' capability, so this guard is about not
// showing someone a page whose every call would 403; it is not the security boundary.
const RaterRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { canUseRater, isLoading, rolesUnknown } = useUserRole();

  // The profile lookup failed, so we don't know whether access was granted — say so rather than
  // redirect, which would read as a denial to someone who does have it.
  if (rolesUnknown) {
    return (
      <div className="page">
        <div className="page-content">
          <div className="loading-message">
            <p>We couldn't confirm your access. Please reload the page or sign in again.</p>
          </div>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="page">
        <div className="page-content">
          <div className="loading-message"><p>Checking access...</p></div>
        </div>
      </div>
    );
  }

  if (!canUseRater) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default RaterRoute;
